var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-tab"},[_c('ulu-order-history-order-table'),_c('ulu-order-history-devices-table'),_c('ulu-order-history-requester')],1)}
var staticRenderFns = []

export { render, staticRenderFns }